export default "__VITE_ASSET__e088d258__"